"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _core = require("@emotion/core");

var _emotionNormalize = require("emotion-normalize");

var _fonts = _interopRequireWildcard(require("./fonts"));

var _mediaQueries = _interopRequireDefault(require("./mediaQueries"));

var _space = _interopRequireDefault(require("./space"));

var _globalStyle = _interopRequireDefault(require("./globalStyle.themes"));

var globalStyle = function globalStyle(brand, colors, textStyles) {
  var _objectSpread2, _table, _objectSpread3, _objectSpread4, _objectSpread5, _objectSpread6, _objectSpread7;

  return (0, _core.css)((_emotionNormalize.normalize, (0, _fonts.getFontString)(brand)), {
    ':root': {
      /* Setting 1rem = 10px */
      fontSize: '62.5%'
    },
    '*': {
      boxSizing: 'border-box'
    },
    html: {
      height: '100%',
      padding: '0',
      margin: '0'
    },
    body: _objectSpread(_objectSpread({
      fontFamily: _fonts.default[brand].body,
      // fontSize: '18px',
      // lineHeight: '1.5',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      color: colors[(0, _globalStyle.default)(brand).color],
      padding: '0',
      // margin: '0',
      backgroundColor: colors[(0, _globalStyle.default)(brand).backgroundColor]
    }, textStyles.globalText.mobile), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, _mediaQueries.default.small, _objectSpread({}, textStyles.globalText.tablet)), _defineProperty(_objectSpread2, _mediaQueries.default.large, _objectSpread({}, textStyles.globalText.desktop)), _objectSpread2)),
    'a, a:hover, a:focus, a:active, a:focus:active': {
      textDecoration: 'none',
      color: colors[(0, _globalStyle.default)(brand).linkColor],
      ':visited': {
        color: colors[(0, _globalStyle.default)(brand).linkColor]
      },
      ':hover': {
        textDecoration: 'none',
        color: colors[(0, _globalStyle.default)(brand).linkColor]
      },
      ':active': {
        textDecoration: 'none',
        color: colors[(0, _globalStyle.default)(brand).linkColor]
      }
    },
    img: {
      maxWidth: '100%'
    },
    svg: {
      display: 'block'
    },
    table: (_table = {
      border: "1px solid ".concat(colors.greymid),
      borderCollapse: 'collapse',
      borderSpacing: 0,
      marginTop: _space.default.medium,
      marginBottom: _space.default.large,
      textAlign: 'left',
      display: 'block',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
      width: 'fit-content',
      maxWidth: '100%'
    }, _defineProperty(_table, _mediaQueries.default.large, {
      display: 'table',
      overflowX: 'visible',
      whiteSpace: 'normal'
    }), _defineProperty(_table, 'thead th', {
      backgroundColor: colors.primary,
      border: "1px solid ".concat(colors.greymid),
      color: "".concat(colors.white, " !important")
    }), _defineProperty(_table, "th", _defineProperty({
      padding: _space.default.small,
      textAlign: 'left'
    }, _mediaQueries.default.small, {
      minWidth: '15rem',
      padding: "".concat(_space.default.medium, " ").concat(_space.default.medium)
    })), _defineProperty(_table, 'tbody td', _defineProperty({
      border: "1px solid ".concat(colors.greymid),
      padding: _space.default.small,
      textAlign: 'left'
    }, _mediaQueries.default.small, {
      minWidth: '15rem',
      padding: "".concat(_space.default.small, " ").concat(_space.default.medium)
    })), _defineProperty(_table, "scrollbarWidth", 'thin'), _defineProperty(_table, "scrollbarColor", "".concat(colors.primary, " transparent")), _defineProperty(_table, '&::-webkit-scrollbar', {
      backgroundColor: 'transparent',
      height: '8px'
    }), _defineProperty(_table, '&::-webkit-scrollbar-track', {
      backgroundColor: 'transparent'
    }), _defineProperty(_table, '&::-webkit-scrollbar-thumb', {
      backgroundColor: colors.primary,
      borderRadius: '2rem'
    }), _table),
    // Global Typography
    h1: _objectSpread(_objectSpread({}, textStyles.headingText.primary.mobile), {}, (_objectSpread3 = {
      fontFamily: _fonts.default[brand][(0, _globalStyle.default)(brand).headingFontFamily]
    }, _defineProperty(_objectSpread3, _mediaQueries.default.small, _objectSpread({}, textStyles.headingText.primary.tablet)), _defineProperty(_objectSpread3, _mediaQueries.default.large, _objectSpread({}, textStyles.headingText.primary.desktop)), _objectSpread3)),
    h2: _objectSpread(_objectSpread({}, textStyles.headingText.secondary.mobile), {}, (_objectSpread4 = {
      fontFamily: _fonts.default[brand][(0, _globalStyle.default)(brand).headingFontFamily]
    }, _defineProperty(_objectSpread4, _mediaQueries.default.small, _objectSpread({}, textStyles.headingText.secondary.tablet)), _defineProperty(_objectSpread4, _mediaQueries.default.large, _objectSpread({}, textStyles.headingText.secondary.desktop)), _objectSpread4)),
    h3: _objectSpread(_objectSpread({}, textStyles.headingText.tertiary.mobile), {}, (_objectSpread5 = {
      fontFamily: _fonts.default[brand].heading
    }, _defineProperty(_objectSpread5, _mediaQueries.default.small, _objectSpread({}, textStyles.headingText.tertiary.tablet)), _defineProperty(_objectSpread5, _mediaQueries.default.large, _objectSpread({}, textStyles.headingText.tertiary.desktop)), _objectSpread5)),
    h4: _objectSpread(_objectSpread({}, textStyles.headingText.quaternary.mobile), {}, (_objectSpread6 = {
      fontFamily: _fonts.default[brand].heading
    }, _defineProperty(_objectSpread6, _mediaQueries.default.small, _objectSpread({}, textStyles.headingText.quaternary.tablet)), _defineProperty(_objectSpread6, _mediaQueries.default.large, _objectSpread({}, textStyles.headingText.quaternary.desktop)), _objectSpread6)),
    p: _objectSpread(_objectSpread({}, textStyles.bodyText.mobile), {}, (_objectSpread7 = {
      fontFamily: _fonts.default[brand].body
    }, _defineProperty(_objectSpread7, _mediaQueries.default.small, _objectSpread({}, textStyles.bodyText.tablet)), _defineProperty(_objectSpread7, _mediaQueries.default.large, _objectSpread({}, textStyles.bodyText.desktop)), _objectSpread7))
  });
};

var _default = globalStyle;
exports.default = _default;